import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { DealerID } from "models";
import type { ExactAccount } from "modules/DealerDetails/components/Invoicing/hooks";

type SearchExactAccountsPayload = {
  dealer_id: DealerID;
  search: string;
};

export const useSearchExactAccountsMutation = () =>
  useTypedMutation<SearchExactAccountsPayload, ExactAccount[]>({
    mutationFn: async payload => (await ApiInstance.post("/accounts/search", payload, ENV.exactBaseURL)).data.accounts ?? [],
    onSuccess: () => null
  });
